import React, { createContext, useState, useContext } from 'react';

const FleetContext = createContext();

export const FleetProvider = ({ children }) => {
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [selectedTrailer, setSelectedTrailer] = useState(null);

  const value = {
    selectedDriver,
    setSelectedDriver,
    selectedTruck,
    setSelectedTruck,
    selectedTrailer,
    setSelectedTrailer,
  };

  return (
    <FleetContext.Provider value={value}>
      {children}
    </FleetContext.Provider>
  );
};

export const useFleet = () => {
  const context = useContext(FleetContext);
  if (context === undefined) {
    throw new Error(
      'useTrucksAndDrivers must be used within a FleetProvider'
    );
  }
  return context;
};

export default FleetContext;
